import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutlined';
import { useAutoTranslation } from 'src/hooks/useTranslate';

export default function SavedIndicator({ savedAt }) {
  const t = useAutoTranslation();

  if (!savedAt) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        color: 'var(--color-active-fg)'
      }}
    >
      <CheckCircleOutlineIcon sx={{ fontSize: 15 }} />
      <Typography
        variant="caption"
        sx={{ fontSize: '0.72rem', fontWeight: 700 }}
      >
        {t('Saved just now')}
      </Typography>
    </Box>
  );
}
